import { useEffect } from 'react';
import PropTypes from 'prop-types';

/* Component needed to conditionally set listener */
export default function EventSetter({ containerRef, onDismiss, children }) {
  useEffect(() => {
    let cancel = false;
    const handleWindowClick = event => {
      if (
        containerRef.current instanceof Element &&
        !containerRef.current.contains(event.target) &&
        typeof onDismiss === 'function'
      ) {
        onDismiss();
      }
    };
    /* wait for click event to finish before setting listener */
    window.requestAnimationFrame(() => {
      /* only addEventListener if not canceled */
      if (!cancel) {
        window.addEventListener('click', handleWindowClick);
      }
    });
    return () => {
      cancel = true;
      window.removeEventListener('click', handleWindowClick);
    };
  }, [containerRef, onDismiss]);
  return children;
}

EventSetter.propTypes = {
  /** Reference to the popper container */
  containerRef: PropTypes.any.isRequired,
  /** Handler executed when user clicks the window / outside the trigger */
  onDismiss: PropTypes.func.isRequired,
  /** Popover/Flyout and its content */
  children: PropTypes.node
};
